import { DiscountManagerState } from "@/vuex/modules/discountManager/discountManager.types";

export const state: DiscountManagerState = {
  discounts: [],
  loading: false,
  pagination: null
};
